import Vue from 'vue';

const CREATE_WARNING_URL = '/warning/';
const DELETE_WARNING_URL = '/warning/';
const WARNING_LIST_URL = '/warning/list';

class WarningService {

    async create(data) {
        return await Vue.prototype.$axios.post(CREATE_WARNING_URL, data);
    }

    async list() {
        return await Vue.prototype.$axios.get(WARNING_LIST_URL);
    }
    async delete(id) {
        return await Vue.prototype.$axios.delete(DELETE_WARNING_URL, {params: {id: id}});
    }
}

export default new WarningService();
